@if (golfParticipantData) {
  <div class="golf-aside">
    <div class="match-info-head text-white mb-0 bg-dark p-2 d-flex">
      <div class="mr-auto">
        {{ golfTournament.name }}
      </div>
      <div>
        <a class="text-reset app-cursor" (click)="close()">{{ 'web.close' | translate }}</a>
      </div>
    </div>
    <div class="mb-3 px-2 pb-4 bg-white">
      <div class="d-flex flex-row align-items-center mb-3 pt-3 border-top border-light2 position-relative">
        @if (participant?.image) {
          <img
            src="{{ participant.image }}"
            alt="{{ golfParticipantData.name }}"
            class="mr-2"
            height="50"
            />
        }
        @if (!participant?.image && golfParticipantData.iso) {
          <img
            src="/img/flags/1x1/{{ golfParticipantData.iso | lowercase }}.svg"
            alt="{{ golfParticipantData.iso }}"
            class="rounded-circle mr-2"
            height="50"
            />
        }
        @if (!participant?.image && !golfParticipantData.iso) {
          <img
            src="/img/default-avatar.png"
            alt=""
            class="rounded-circle mr-2"
            height="50"
            />
        }
        <div>
          <h5 class="font-weight-bold d-flex align-items-center flex-nowrap mb-1 app-text">
            <a
              [routerLink]="['/page/golf/participant/golf-62/', golfParticipantData.id]"
              class="text-reset"
              >{{ golfParticipantData.name }}</a
              >
            </h5>
          </div>
        </div>
        <div class="table-responsive">
          <div class="match-info__table small pb-2 text-center">
            @if (golfParticipantData.money) {
              <div
                class="match-info__table__row app-data-row-data player-record"
                >
                <div class="match-info__table__cell text-left font-weight-bold border-top">
                  {{ 'web.money' | translate }}:
                </div>
                <div class="match-info__table__cell text-left font-weight-bold border-top">
                  {{ golfParticipantData.money | localeCurrency : golfTournament.currency }}
                </div>
              </div>
            }
            @if (golfParticipantData.points) {
              <div
                class="match-info__table__row app-data-row-data player-record"
                >
                <div class="match-info__table__cell text-left font-weight-bold border-top">
                  {{ 'web.points' | translate }}:
                </div>
                <div class="match-info__table__cell text-left font-weight-bold border-top">
                  {{ golfParticipantData.points }}
                </div>
              </div>
            }
            @if (golfParticipantData?.position) {
              <div
                class="match-info__table__row app-data-row-data player-record"
                >
                <div class="match-info__table__cell text-left font-weight-bold border-top">
                  {{ 'web.tournament-position' | translate }}:
                </div>
                <div class="match-info__table__cell text-left font-weight-bold border-top">
                  {{ golfParticipantData.position }}
                  @if (golfParticipantData.score) {
                    ({{ 'web.score'|translate }}: {{ golfParticipantData.score }})
                  }
                </div>
              </div>
            }
            @if (participant?.ranking) {
              <div class="match-info__table__row app-data-row-data player-record">
                <div class="match-info__table__cell text-left font-weight-bold border-top">
                  {{ 'web.ranking' | translate }}:
                </div>
                <div class="match-info__table__cell text-left font-weight-bold border-top">
                  {{ participant.ranking.rank }} ({{ participant.ranking.year }})
                </div>
              </div>
            }
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-sm stage-table golf-table">
            <thead>
              <tr class="bg-light2">
                <td class="small align-middle"></td>
                @for (round of golfParticipantData.rounds; track round) {
                  <td class="small align-middle">{{ round.sequence }}</td>
                }
                <td class="small align-middle">{{ 'web.sum' | translate }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-nowrap text-left">
                  <strong>Eagles</strong>
                </td>
                @for (round of golfParticipantData.rounds; track round) {
                  <td>
                    {{ round.eagles }}
                  </td>
                }
                <td>{{ golfRoundsSum?.eagles }}</td>
              </tr>
              <tr>
                <td class="text-nowrap text-left">
                  <strong>Birdies</strong>
                </td>
                @for (round of golfParticipantData.rounds; track round) {
                  <td>
                    {{ round.birdies }}
                  </td>
                }
                <td>{{ golfRoundsSum?.birdies }}</td>
              </tr>
              <tr>
                <td class="text-nowrap text-left">
                  <strong>Pars</strong>
                </td>
                @for (round of golfParticipantData.rounds; track round) {
                  <td>
                    {{ round.pars }}
                  </td>
                }
                <td>{{ golfRoundsSum?.pars }}</td>
              </tr>
              <tr>
                <td class="text-nowrap text-left">
                  <strong>Bogeys</strong>
                </td>
                @for (round of golfParticipantData.rounds; track round) {
                  <td>
                    {{ round.bogeys }}
                  </td>
                }
                <td>{{ golfRoundsSum?.bogeys }}</td>
              </tr>
              <tr>
                <td class="text-nowrap text-left">
                  <strong>Double Bogeys</strong>
                </td>
                @for (round of golfParticipantData.rounds; track round) {
                  <td>
                    {{ round.double_bogeys }}
                  </td>
                }
                <td>{{ golfRoundsSum?.double_bogeys }}</td>
              </tr>
              <tr>
                <td class="text-nowrap text-left">
                  <strong>Other Scores</strong>
                </td>
                @for (round of golfParticipantData.rounds; track round) {
                  <td>
                    {{ round.other_scores }}
                  </td>
                }
                <td>{{ golfRoundsSum?.other_scores }}</td>
              </tr>
              @if (golfParticipantData?.rounds && golfParticipantData.rounds[0].strokes) {
                <tr>
                  <td class="text-nowrap text-left">
                    <strong>Strokes</strong>
                  </td>
                  @for (round of golfParticipantData.rounds; track round) {
                    <td>
                      <strong>{{ round.strokes }}</strong>
                    </td>
                  }
                  <td><strong>{{ golfRoundsSum?.strokes }}</strong></td>
                </tr>
              }
              <tr>
                <td class="text-nowrap text-left">
                  <strong>Thru</strong>
                </td>
                @for (round of golfParticipantData.rounds; track round) {
                  <td>
                    {{ round.thru }}
                  </td>
                }
                <td>{{ golfRoundsSum?.thru }}</td>
              </tr>
              <tr>
                <td class="text-nowrap text-left">
                  <strong>Holes In One</strong>
                </td>
                @for (round of golfParticipantData.rounds; track round) {
                  <td>
                    {{ round.holes_in_one }}
                  </td>
                }
                <td>{{ golfRoundsSum?.holes_in_one }}</td>
              </tr>
              <tr>
                <td class="text-nowrap text-left">
                  <strong>{{ 'web.score' | translate }}</strong>
                </td>
                @for (round of golfParticipantData.rounds; track round) {
                  <td>
                    {{ round.score }}
                  </td>
                }
                <td>{{ golfRoundsSum?.score }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        @for (round of golfRounds; track round) {
          <div class="table-responsive">
            <strong>
              @if (round.playoff) {
                PLAY OFF -
              }
              {{ 'web.round' | translate | titlecase }} {{ round.round }}
            </strong>
            <table class="table table-sm stage-table golf-table">
              <thead>
                <tr class="bg-light2">
                  <td class="small text-nowrap text-left">{{ 'web.hole' | translate | titlecase }}</td>
                  @for (score of round.scores; track score) {
                    <td class="small align-middle">
                      <div
                        class="bg-golf"
                        data-toggle="tooltip"
                        data-placement="top"
                        [title]="('web.yardage' | translate) + ': ' + score.yardage"
                        >
                        {{ score.number }}
                      </div>
                    </td>
                  }
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-nowrap text-left">
                    <strong>PAR</strong>
                  </td>
                  @for (score of round.scores; track score) {
                    <td>
                      <div class="bg-golf">{{ score.par }}</div>
                    </td>
                  }
                </tr>
                <tr>
                  <td class="text-nowrap text-left">
                    <strong>{{ golfParticipantData.name }}</strong>
                  </td>
                  @for (score of round.scores; track score) {
                    <td>
                      <div
                        [class.--dark-text]="score.strokes !== 0"
                                    [class]="
                                        '--dark-text bg-golf bg-golf bg-golf-' +
                                        (score.strokes !== 0 ? score.strokes - score.par : '')
                                    "
                        >
                        {{ score.strokes }}
                      </div>
                    </td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
        }
        <div class="golf-legend mt-3 d-flex justify-content-start flex-wrap">
          <div class="p-1"><span class="bg-golf bg-golf--3">&nbsp;</span> Double-Eagle</div>
          <div class="p-1"><span class="bg-golf bg-golf--2">&nbsp;</span> Eagle</div>
          <div class="p-1"><span class="bg-golf bg-golf--1">&nbsp;</span> Birdie</div>
          <div class="p-1"><span class="bg-golf bg-golf-0">&nbsp;</span> Par</div>
          <div class="p-1"><span class="bg-golf bg-golf-1">&nbsp;</span> Bogey</div>
          <div class="p-1"><span class="bg-golf bg-golf-2">&nbsp;</span> Double-Bogey</div>
          <div class="p-1"><span class="bg-golf bg-golf-3">&nbsp;</span> 3+ Bogey</div>
        </div>
      </div>
    </div>
  }
